import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed } from 'vue';
import VideoPlayerMinimal from '~/components/UIComponents/VideoPlayerMinimal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PopcornExplainer',
  setup(__props) {

const { i18n } = useContext();
const videoSrc = `https://static.gala.games/gala-film/videos/gala_film_popcorn.mp4`;

const heading = computed(() => {
  return i18n.t('components.nodes.popcornExplainer.rewards') as string;
});

const body = computed(() => {
  return [
    i18n.t('components.nodes.popcornExplainer.ifYou') as string,
    i18n.t('components.nodes.popcornExplainer.onceOurEcosystem') as string,
    i18n.t('components.nodes.popcornExplainer.untilThen') as string,
  ];
});

const items = computed(() => {
  return [
    i18n.t('components.nodes.popcornExplainer.whyPopcorn') as string,
    i18n.t('components.nodes.popcornExplainer.earnPopcorn') as string,
    i18n.t('components.nodes.popcornExplainer.collectPopcorn') as string,
    i18n.t('components.nodes.popcornExplainer.morePopcorn') as string,
  ];
});

return { __sfc: true,i18n, videoSrc, heading, body, items, VideoPlayerMinimal }
}

})